import { UserRole } from '@40seas/entities/users';
import { ReactNode } from 'react';
import { LayoutStrategyProvider, LayoutStrategyProviderParams } from './layoutStrategyProvider';
import { isGuestRole } from '@40seas/frontend/libs/hooks';

export class GuestPortalStrategyProvider implements LayoutStrategyProvider {
    constructor(private readonly params: LayoutStrategyProviderParams) {}

    shouldApply = (): boolean => {
        const shouldAuth = window.location.pathname.endsWith('/signup') || window.location.pathname.endsWith('/login');

        if (!this.params.user.role) return false;

        return isGuestRole(this.params.user.role as UserRole) && !shouldAuth;
    };

    showLayout = ({ children }: { children: ReactNode }) => children;
}
